import * as Api from '@ViewModels';
import { IRegEdActionNeededItem } from './types';
import { useAccountUsesRegEd } from './useAccountUsesRegEd';
import { useRegEdActionNeededQuery } from './useRegEdActionNeededQuery';

/**
 * The outstanding compliance action for one piece, or undefined when it owes nothing. Reads the
 * account-wide list rather than querying per parent, so a table of rows shares one request.
 */
export const useRegEdParentActionNeeded = (
	parentId?: string,
	impersonationContext?: Api.IImpersonationContext
): IRegEdActionNeededItem | undefined => {
	const usesRegEd = useAccountUsesRegEd(impersonationContext);
	const { data } = useRegEdActionNeededQuery({ enabled: usesRegEd, impersonationContext });
	return parentId ? data?.find(item => item.parentId === parentId) : undefined;
};
